import React from 'react';
import PlotCard from '../PlotCard';

const DayCard = ({
  seriesEnergy,
  seriesPeakPower,
}) => {

  return (
    <PlotCard
      cardTitle={"Last 24 hours"}
      cardSubtitle={"Hourly energy and peak demand"}
      seriesEnergy={seriesEnergy}
      seriesPeakPower={seriesPeakPower}
      binMs={3600 * 1000}
    />
  )
}

export default DayCard;
